import { Controller } from 'stimulus'
import 'moment'
import Rails from '@rails/ujs'
import emailValidator from '@app/javascript/controllers/mixins/emailValidator.js'

export default class extends Controller {
  static get targets() {
    return [
      'titleInput',
      'titleLiveRegion',
      'attendeesInputVisible',
      'attendeesInputVisibleLiveRegion',
      'attendeesInputHidden',
      'attendeesMenuOption',
      'attendeesSelection'
    ]
  }

  static values = {
    field: String,
    fieldFor: String,
    validationModel: String
  }

  validatePresence() {
    const fieldFor = this.fieldForValue
    const validity = $(this.titleInputTarget)[0].validity
    const determiner = fieldFor[0].match(/[aeiou]/i) ? 'an' : 'a'
    let errorMessage = ''

    if (validity.valueMissing) errorMessage = `Please enter ${determiner} ${fieldFor}`

    $(this.titleLiveRegionTarget).text(errorMessage)
  }

  validateTitle() {
    const field = this.fieldValue || 'title'
    const fieldFor = this.fieldForValue || 'action'
    const validity = $(this.titleInputTarget)[0].validity
    let errorMessage = ''

    if (validity.valueMissing) {
      errorMessage = `Please add a ${field} for this ${fieldFor}.`
    } else if (validity.patternMismatch) {
      const characterLimit = $(this.titleInputTarget).data('characterLimit')
      errorMessage = `Please enter a ${field} with ${characterLimit} characters or fewer.`
    }

    $(this.titleLiveRegionTarget).text(errorMessage)
  }

  validateLinkUrl() {
    const validity = $(this.titleInputTarget)[0].validity
    let error = ''
    const urlRegex = require('url-regex')
    const validUrl = urlRegex({ strict: false }).test($(this.titleInputTarget)[0].value)
    if (validity.valueMissing || !validUrl) {
      error = 'Please enter a valid URL (e.g. mywebsite.com)'
      $(this.titleInputTarget).parent().addClass('is-invalid')
    } else {
      $(this.titleInputTarget).parent().removeClass('is-invalid')
    }
    $(this.titleLiveRegionTarget).text(error)
  }

  validateAttendees() {
    if (!this.hasAttendeesInputVisibleTarget) return
    const hiddenInput = $(this.attendeesInputVisibleTarget).closest('.organism-typeahead-multiselect').find(".organism-pill-list input[type='hidden']")
    const hiddenInputCount = hiddenInput.length

    let error = ''
    if (hiddenInputCount < 1) {
      error = 'Please add at least one user as an attendee.'
      $(this.attendeesInputVisibleTarget).parent().addClass('is-invalid')
    } else {
      $(this.attendeesInputVisibleTarget).parent().removeClass('is-invalid')
    }

    $(this.attendeesInputVisibleTarget).siblings('.particle-live-region').text(error)
  }

  /**
   * Validate contacts phone uniqueness
   */
  validateContactPhone() {
    const phone = $(this.titleInputTarget)[0].value
    const validationModel = this.validationModelValue
    const data = new FormData()
    const regex = /^((\d+)[- ]?)?\(?(\d+)\)?([- ]?(\d+)){0,}$/
    let errorMessage = ''

    data.append('phone', phone)
    data.append('model', validationModel)

    if (phone) {
      if (!regex.test(phone)) {
        errorMessage = 'Phone Number has the wrong format.'
      } else {
        Rails.ajax({
          url: '/contacts/phone_validations',
          type: 'POST',
          data: data,
          success: (response) => {
            if (response && response.message === false) {
              errorMessage = 'Phone Number already in use. Please enter a unique Phone Number.'
              $(this.titleLiveRegionTarget).text(errorMessage)
            }
          }
        })
      }
    }

    $(this.titleLiveRegionTarget).text(errorMessage)
  }

  validateEmail() {
    const email = $(this.titleInputTarget)[0].value
    const validationModel = this.validationModelValue
    const data = new FormData()
    let errorMessage = ''

    data.append('email', email)
    data.append('model', validationModel)

    if (email) {
      if (!emailValidator(email)) {
        errorMessage = 'Email has the wrong format.'
      }
    }

    $(this.titleLiveRegionTarget).text(errorMessage)
  }
}
